import { useEffect } from 'react';

const useGlobalShortcut = (shortcut, callback) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      const isCtrlPressed = event.ctrlKey || event.metaKey;
      const key = event.key.toLowerCase();

      if (isCtrlPressed && key === shortcut.toLowerCase()) {
        event.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shortcut, callback]);
};

export default useGlobalShortcut; 